import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Secret } from '@interfaces/interfaces';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BffApiService {
  apiUrl: string = environment.vestraApiUrl + 'api/v1/company';
  headers = { Accept: 'application/json' };
  options = { headers: this.headers, withCredentials: true };

  constructor(private http: HttpClient) {}

  getToken(): Observable<any> {
    const url = `${environment.vestraApiUrl}/sanctum/csrf-cookie`;
    return this.http.get(url, { withCredentials: true });
  }

  getCookie(): Observable<any> {
    const url: string = environment.vestraApiUrl + 'sanctum/csrf-cookie';
    return this.http.get(url, this.options);
  }

  // SESSION RELATED
  login(form: any): Observable<any> {
    const url: string = `${this.apiUrl}/login?email=${form.email}&password=${form.password}`;
    return this.http.post(url, '', this.options);
  }

  logout(): Observable<any> {
    const url: string = `${this.apiUrl}/logout`;
    return this.http.post(url, '', this.options);
  }

  forgotPassword(form: any): Observable<any> {
    const url: string = `${this.apiUrl}/login?email=${form.email}`;
    return this.http.post(url, '', this.options);
  }

  /**
   * @deprecated TODO what is this endpoint for ?
   * * */
  updatePassword(): Observable<any> {
    const url: string = `${this.apiUrl}/update-password`;
    return this.http.post(url, '', this.options);
  }

  resetPassword(): Observable<any> {
    const url: string = `${this.apiUrl}/reset-password`;
    return this.http.get(url, this.options);
  }

  // REGISTRATION RELATED
  register(form: any): Observable<any> {
    const url: string = `${this.apiUrl}/register`;
    return this.http.post(url, form, this.options);
  }

  getVerify(id: string | number, hash: string | number): Observable<any> {
    const url: string = `${this.apiUrl}/email/verify/${id}/${hash}`;
    return this.http.get(url, this.options);
  }

  postVerify(): Observable<any> {
    const url: string = `${this.apiUrl}/email/verification-notification`;
    return this.http.post(url, '', this.options);
  }

  getConfirmedPasswordStatus(): Observable<any> {
    const url: string = `${this.apiUrl}/confirmed-password-status`;
    return this.http.get(url, this.options);
  }

  confirmPassword(form: any): Observable<any> {
    const url: string = `${this.apiUrl}/confirm-password?password=${form.password}`;
    return this.http.post(url, '', this.options);
  }

  getStock(): Observable<any> {
    const url: string = `${this.apiUrl}/stock`;
    return this.http.get(url, this.options);
  }

  getSecret(): Observable<any> {
    const url: string = `${this.apiUrl}/settings/secrets`;
    return this.http.get(url, this.options);
  }
  postSecret(secret: Secret): Observable<any> {
    const url: string = `${this.apiUrl}/settings/secrets?name=bcprisme&url=https://vpn.bestinfo.ch:54789&secret=9jIGiuZer87UBYw1ey4ui5AgGd6E7Ss`;
    return this.http.post(url, secret, this.options);
  }

  getProducts(id: number | undefined = undefined, page: number = 1): Observable<any> {
    let url: string = `${this.apiUrl}/product?page=${page}`;
    if (id !== undefined) {
      url += `&id=` + id;
    }
    return this.http.get(url, this.options);
  }

  getProfile(): Observable<any> {
    const url: string = `${this.apiUrl}/profile-information`;
    return this.http.get(url, this.options);
  }

  putProfileInfo(form: any): Observable<any> {
    const url: string = `${this.apiUrl}/profile-information`;
    return this.http.put(url, form, this.options);
  }

  addProduct(stockProd: FormData) {
    const url: string = `${this.apiUrl}/product`;
    return this.http.post(url, stockProd, this.options);
  }
  addProductVariant(product_id: string | number, form: any) {
    const url: string = `${this.apiUrl}/product?id=${product_id}`;
    return this.http.post(url, form, this.options);
  }
  editProductVariant(product_id: any, form: FormData): Observable<any> {
    const url: string = `${this.apiUrl}/product/${product_id}`;
    return this.http.post(url, form, this.options);
  }
  editSaleStatus(order_id: any, newStatus: any) {
    const url: string = `${this.apiUrl}/product/id=` + order_id;
    return this.http.put(url, newStatus, this.options);
  }

  getUserRole() {
    const url: string = `${this.apiUrl}/user/role`;
    return this.http.put(url, this.options);
  }

  sendVerificationEmail() {
    const url = `${this.apiUrl}/email/verification-notification`;
    return this.http.post(url, '', this.options);
  }

  /***
   * orders
   */
  getOrder() {
    const url: string = `${this.apiUrl}/orders`;
    return this.http.get(url, this.options);
  }

  putOrder(id: string, status: any) {
    const url: string = `${this.apiUrl}/orders/${id}`;
    return this.http.put(url, status, this.options);
  }

  /***
   * Photo
   */
  getPicture(product: any, variant: any) {
    const url: string = `${this.apiUrl}/product/${product}/variant/${variant}/photo`;
    return this.http.get(url, this.options);
  }

  putPicture(product: any, variant: any, img: any) {
    const url: string = `${this.apiUrl}/product/${product}/variant/${variant}/photo`;
    return this.http.put(url, img, this.options);
  }

  deletePicture(product: any, variant: any) {
    const url: string = `${this.apiUrl}/product/${product}/variant/${variant}/photo`;
    return this.http.delete(url, this.options);
  }

  postLogo(img: any) {
    var payload = { logo: img };
    console.log(payload);
    const url: string = `${this.apiUrl}/profile-information/logo`;
    return this.http.post(url, payload, this.options);
  }

  getPropreties() {
    const url: string = `${environment.vestraApiUrl}api/v1/shop/material/properties`;
    return this.http.get(url, this.options);
  }

  getMaterials() {
    const url: string = `${environment.vestraApiUrl}api/v1/shop/material/compositions`;
    return this.http.get(url, this.options);
  }

  getLinings() {
    const url: string = `${environment.vestraApiUrl}api/v1/shop/material/linings`;
    return this.http.get(url, this.options);
  }

  getCategories() {
    const url: string = `${environment.vestraApiUrl}api/v1/shop/categories`;
    return this.http.get(url, this.options);
  }

  getColors(): Observable<any> {
    const url = `${environment.vestraApiUrl}api/v1/shop/colors`;
    return this.http.get(url, this.options);
  }

  getSizes(): Observable<any> {
    const url = `${environment.vestraApiUrl}api/v1/shop/sizes`;
    return this.http.get(url, this.options);
  }
}
